module.exports = __webpack_public_path__ + "883e007b2d2ea60d7a7c634ebe0ff5dd.svg";